// usePermissions — Hook pour lire la matrice de permissions du rôle courant
// Synchronise les permissions UI avec celles du backend (middleware/permissions.js)
import { useEffect, useState, useCallback } from 'react';
import { api } from './api';

let cache = null; // partagé entre composants

export function usePermissions() {
  const [perms, setPerms] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/assos/permissions');
      cache = data;
      setPerms(data);
    } catch {
      cache = { role: null, permissions: {} };
      setPerms(cache);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => {
    if (cache) { setPerms(cache); setLoading(false); return; }
    refresh();
  }, [refresh]);

  /** can('membres', 'list') → boolean */
  const can = useCallback((module, action) => {
    if (!perms?.permissions) return false;
    return !!perms.permissions[module]?.[action];
  }, [perms]);

  return { role: perms?.role || null, can, loading, refresh };
}

// Reset à appliquer au logout
export function clearPermissionsCache() { cache = null; }
